// extracted by mini-css-extract-plugin
module.exports = {"infoIcons":"infoIcon-module--infoIcons--ZqgYF","icon":"infoIcon-module--icon--3fnI6","buyout":"infoIcon-module--buyout--3hQns","noVat":"infoIcon-module--noVat--1BGbm"};